import React, { useEffect } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Section, SectionHeading } from "@/components/primitives";
import { StrategyModules } from "@/components/strategyModules";
import { RiskSection } from "@/components/marketing";
import { trackEvent } from "@/lib/api";

export default function Strategies() {
  useEffect(() => {
    trackEvent("page_view", { page: "strategies" });
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="Strategies"
        title="Six arbitrage strategies. One engine."
        sub="Q-Core is designed to analyze multiple arbitrage opportunities simultaneously. Each strategy is a technology capability, subject to market conditions, liquidity, fees, and execution feasibility. Expand any module to see how it works."
      />
      <Section grid>
        <SectionHeading
          eyebrow="Interactive Modules"
          title="Explore each strategy."
          sub="Every module includes a market visualization, an example workflow, and its key risk considerations."
          className="mb-10"
        />
        <StrategyModules />
      </Section>
      <Section>
        <RiskSection />
      </Section>
    </div>
  );
}
